import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Box from '@repo/ui/box'
import Loader from '@repo/ui/loader'
import { LogSection } from '@repo/ui/log-section'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getHostFamilyOlComments } from '../../../../../api/host-families/host-family-ol-comments/get-host-family-ol-comments'

type Props = {
  id: number
}

const HostFamilyOLComments = ({ id }: Props) => {
  const { data: hostFamilyOLComments, isPending } = useQuery({
    queryKey: ['host-family-ol-comments'],
    queryFn: () => getHostFamilyOlComments({ hostFamilyId: id })
  })

  if (isPending) return <Loader center />

  return (
    <Box className="bg-white-hover rounded-lg border border-grey-light">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        Commentaires OL
      </Typography>
      <div className="h-4" />
      <LogSection
        logItemClassName="bg-white"
        data={
          hostFamilyOLComments?.data?.map((comment) => ({
            comment: comment.comment,
            updatedAt: new Date(comment.updatedAt)
          })) || []
        }
        dateFormatter={(date) => DateFormatter.ddMMyyyyHHmm(date)}
      />
    </Box>
  )
}

export default HostFamilyOLComments
